import * as React from 'react'
import {
  MigrationResult,
  MigrationContext,
  MigrationStageStatus,
} from '../../../api'
import { Box, Typography, Accordion } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import clsx from 'clsx'

interface MigrationErrorProps {
  className?: string
  result: MigrationResult
  context: MigrationContext
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& ul': {
        margin: 0,
        padding: 0,
        paddingLeft: theme.spacing(8),
      },
    },
  }),
)

export const MigrationError: React.FunctionComponent<MigrationErrorProps> = ({
  context,
  result,
  className,
}) => {
  const classes = useStyles({})

  if (context === null) return null

  const hasContextError =
    context.stageStatus === MigrationStageStatus.Faulted && context.error
  const hasError = result.errors.length > 0 || hasContextError

  if (!hasError) return null

  return (
    <Accordion title="Migration Errors" id="MigrationErrors" initiallyExpanded>
      <Box className={clsx(classes.root, className)}>
        <ul>
          {hasContextError && (
            <li>
              <Typography>{context.error}</Typography>
            </li>
          )}
          {result.errors.map((error, idx: number) => (
            <li key={`MigrationError::${idx}`}>
              <Typography>
                {error.message}
              </Typography>
            </li>
          ))}
        </ul>
      </Box>
    </Accordion>
  )
}
